import api from "../../api";
import type {
  ContentListingPageData,
  LibraryApiResponse,
  LibraryContentData,
  LibrarySectionConfig,
} from "../../../@types/portalAluno";
import { mapApiItemsToCards } from "../../../utils/portalAluno/mappers/contentCardMapper";
import { mapLibraryResponse } from "../../../utils/portalAluno/mappers/libraryMapper";

export const getLibraryContents = async (): Promise<LibraryContentData> => {
  const response = await api.get<LibraryApiResponse>("mobile/biblioteca");

  return mapLibraryResponse(response.data);
};

export const getLibraryListing = async (
  section: LibrarySectionConfig,
  offset: number
): Promise<ContentListingPageData> => {
  const response = await api.get<unknown>("mobile/listagem", {
    params: { offset, tipo: section.apiType },
  });

  if (!Array.isArray(response.data)) {
    throw new Error("A API retornou uma listagem da Biblioteca inválida.");
  }

  return {
    cards: mapApiItemsToCards(response.data, section.sourceType),
    itemCount: response.data.length,
  };
};
